export var NOT_DESKTOP_MAX_WIDTH = 1024;
export var SCROLLABLE_ELEMENT_CLASSNAME = '__nw_scrollable_element__';
/*
ATTN: These values should mirror:
* ./header-variables.less

If you change any values here, make sure you change them there too.
*/

export var DEFAULT_HEADER_HEIGHT = 82;
export var DEFAULT_HEADER_HEIGHT_MOBILE = 66;
export var DEFAULT_STICKY_FOOTER_HEIGHT = 64; // should correspond with @not-desktop

export var STICKY_FOOTER_BREAKPOINT = "(max-width: ".concat(NOT_DESKTOP_MAX_WIDTH, "px)");
export var GRID_VIEWPORT_SIZE_DESKTOP = 1280;
export var GUTTER_WIDTH_DESKTOP = 64;
export var MODAL_BORDER_RADIUS = 8;